import { Injectable } from "@angular/core";
import { IDateDrillDownSelectedItem } from "~app/common/components/date-drill-down/components/date-drill-down-selector/models/dateDrillDownSelectedItem";
import { DateUtils } from "~app/common/utils/date-utils";
import { Fordelningstyp, GridPeriod } from "../models/justeraLeveransplanModel";

@Injectable({
    providedIn: "root"
})
export class JlpPeriodService {

    getLastDayOfMonth(date: string) {
        if (date.endsWith("-")) {
            date = `${date}01`;
        }

        return DateUtils.endOfMonth(date);
    }

    addFirstDayOfMonth(date: string) {
        if (date.endsWith("-")) {
            date = `${date}01`;
        }

        return date;
    }

    getPeriods(periodFrom: any, periodTom: any): GridPeriod {
        const period = new GridPeriod();
        period.from = periodFrom;
        period.to = new Date(DateUtils.endOfMonth(periodTom));
        period.type = Fordelningstyp.period;
        period.periodMonth = new Date();
        return period;
    }

    onDateSelected(item: IDateDrillDownSelectedItem) {
        const period = new GridPeriod();
        period.from = item.periodStart;
        period.to = item.periodEnd;
        period.type = item.periodType;
        period.periodMonth = new Date();
        return period;
    }

}
